import React, { useState, useEffect, useRef } from 'react';
import './Testimonial.css';

const Testimonials = () => {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [autoScrollPaused, setAutoScrollPaused] = useState(false);
  const timeoutRef = useRef(null);

  const testimonials = [
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t7.jpg',
      name: 'Saanvi',
      text: 'The training sessions are very well-structured, and the coaches focus on technique and improvement. I can feel my skills getting better with Enrolled my son who is 8 years old for swimming. Head coach and her assistant are really good in teaching the techniques. Good job class.'
    },
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t8.jpg',
      name: 'Aadhya',
      text: 'The overall Coaches are very polite and helpful. I was very afraid of water. She patiently taught me swimming. I enjoy the classes were fantastic! The coaches are patient, knowledgeable, and always encourage you to push your limits in a positive way.'
    },
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t5.jpg',
      name: 'Aparna',
      text: 'Coaches are superb. I am sticking to this centre because of Joy. They are humble and patiently trains. I will rate them 9 out of 10.'
    },
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t9.jpg',
      name: 'Varsha Santosh',
      text: 'The coaching quality is outstanding. The trainers pay attention to every detail, ensuring that I master the right skill, I enrolled my son who is 8 years old for swimming. Head coach and her assistant are really good in teaching the techniques. Good job step by step.'
    },
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t10.jpg',
      name: 'Nishtha Chopra',
      text: 'Coaches are very polite and helpful. I was very afraid of water. They patiently taught me swimming. I enjoy the classes.'
    },
    { 
      avatar: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/t1.jpg',
      name: 'Kunal Joshi',
      text: 'Coaches are great. I can see evidently much difference in my swimming than earlier. Coach pushes me to go beyond my limits and encourages me to become a better swimmer.'
    },
  ];
  

  useEffect(() => {
    if (autoScrollPaused) return;

    const interval = setInterval(() => {
      const nextIndex = (activeIndex + 1) % testimonials.length;
      scrollToIndex(nextIndex);
    }, 3000);

    return () => clearInterval(interval);
  }, [activeIndex, autoScrollPaused]);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const index = Math.round(trackRef.current.scrollLeft / trackRef.current.offsetWidth);
    setActiveIndex(index);
    pauseAutoScroll();
  };

  const pauseAutoScroll = () => {
    setAutoScrollPaused(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setAutoScrollPaused(false);
    }, 5000);
  };

  const scrollToIndex = (index) => {
    if (!trackRef.current) return;
    trackRef.current.scrollTo({
      left: index * trackRef.current.offsetWidth,
      behavior: 'smooth'
    });
  };

  const handleTouchStart = (e) => {
    pauseAutoScroll();
    const touch = e.nativeEvent.touches[0];
    if (e.cancelable) e.preventDefault();
  };

  const scrollLeft = () => {
    const prevIndex = (activeIndex - 1 + testimonials.length) % testimonials.length;
    scrollToIndex(prevIndex);
  };

  const scrollRight = () => {
    const nextIndex = (activeIndex + 1) % testimonials.length;
    scrollToIndex(nextIndex);
  };

  return (
    <section className="testimonial-container">
      <h2 className="explore-title">Testimonial</h2>
      
      <div className="testimonial-wrapper">
        <button className="scroll-button left" onClick={scrollLeft}>&lt;</button>
        <div 
          className="testimonial-track"
          ref={trackRef}
          onScroll={handleScroll}
          onTouchStart={handleTouchStart}
          onTouchMove={pauseAutoScroll}
        >
          {testimonials.map((testimonial, index) => (
            <article 
              key={index}
              className={`testimonial-card ${index === activeIndex ? 'active' : ''}`}
            >
              <div className="avatar-container">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="client-avatar"
                />
              </div>
              <h3 className="client-name">{testimonial.name}</h3>
              <p className="testimonial-text">{testimonial.text}</p>
            </article>
          ))}
        </div>
        <button className="scroll-button right" onClick={scrollRight}>&gt;</button>
      </div>

      <div className="navigation-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => {
              scrollToIndex(index);
              pauseAutoScroll();
            }}
            aria-label={`View testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;